<form [formGroup]="formGroup">
  <snelstart-ui-text-form-control [disabledControl]="true"
                                  class="custom-input-400"
                                  formControlName="achternaamBelastingplichtige"
                                  id="achternaamBelastingplichtige"
                                  label="Naam"
  >
  </snelstart-ui-text-form-control>
  <snelstart-ui-bsn-form-control [disabledControl]="true"
                                 class="custom-input-400"
                                 formControlName="fiscaalNummer"
                                 id="fiscaalNummer"
                                 label="Fiscaal nummer"
  >
  </snelstart-ui-bsn-form-control>
  <snelstart-ui-select-form-control [disabledControl]="true"
                                    class="custom-input-400"
                                    [options]="this.optionsUitstelType"
                                    formControlName="soortUitstelVerzoek"
                                    id="soortUitstelVerzoek"
                                    label="Soort uitstel"
  >
  </snelstart-ui-select-form-control>
  <snelstart-ui-date-form-control (change)="this.saveForm()"
                                  [disabledControl]="this.formGroup.get('belastingmiddel')?.value === UitstelGegevensBelastingmiddel.INKOMSTENBELASTING || this.formGroup.get('datumUitstelTot')?.value !== null"
                                  [label]="this.formGroup.get('belastingmiddel')?.value === UitstelGegevensBelastingmiddel.INKOMSTENBELASTING ? 'Start aangiftejaar' : 'Start boekjaar'"
                                  class="custom-input-400"
                                  formControlName="boekjaarStart"
                                  id="boekjaarStart">
  </snelstart-ui-date-form-control>
  <snelstart-ui-date-form-control (change)="this.saveForm()"
                                  [disabledControl]="this.formGroup.get('belastingmiddel')?.value === UitstelGegevensBelastingmiddel.INKOMSTENBELASTING || this.formGroup.get('datumUitstelTot')?.value !== null"
                                  [label]="this.formGroup.get('belastingmiddel')?.value === UitstelGegevensBelastingmiddel.INKOMSTENBELASTING ? 'Eind aangiftejaar' : 'Eind boekjaar'"
                                  class="custom-input-400"
                                  formControlName="boekjaarEind"
                                  id="boekjaarEind">
  </snelstart-ui-date-form-control>
  @if (this.formGroup.get('datumUitstelTot')?.value !== null) {
    <snelstart-ui-date-form-control [disabledControl]="true"
                                    class="custom-input-400"
                                    formControlName="datumUitstelTot"
                                    id="datumUitstelTot"
                                    label="Uitstel tot"
    >
    </snelstart-ui-date-form-control>
  }
  @if (this.formGroup.get('datumIngeleverd')?.value !== null) {
    <snelstart-ui-date-form-control [disabledControl]="true"
                                    class="custom-input-400"
                                    formControlName="datumIngeleverd"
                                    id="datumIngeleverd"
                                    label="Datum ingeleverd"
    >
    </snelstart-ui-date-form-control>
  }
  @if (this.formGroup.get('omschrijving')?.value !== null) {
    <snelstart-ui-textarea-form-control [disabledControl]="true"
                                        [rows]="7"
                                        class="custom-input-400"
                                        formControlName="omschrijving"
                                        id="omschrijving"
                                        label="Omschrijving"
    >
    </snelstart-ui-textarea-form-control>
  }
  @if (this.formGroup.get('datumUitstelTot')?.value !== null && this.formGroup.get('datumIngeleverd')?.value === null) {
    <snelstart-ui-textarea-form-control (change)="this.saveForm()"
                                        [rows]="6"
                                        class="custom-input-400"
                                        formControlName="motivatieBijzonderUitstel"
                                        id="motivatieBijzonderUitstel"
                                        label="Motivatie aanvullend uitstel"
    >
    </snelstart-ui-textarea-form-control>
  }
</form>
